// extracted by mini-css-extract-plugin
export default {"wrapper":"PageLoader_wrapper__dUgF5"};